<template>
  <div class="main-nav">
    <v-app-bar dense clipped-left app>
      <v-app-bar-nav-icon v-if="isMobile && isAllowed" @click="toggleDrawer"></v-app-bar-nav-icon>
      <v-toolbar-title class>
        <router-link to="/">
          <img class="logo-img" :src="require('@/assets/imgs/logo3.png')" alt="logo" />
          <span class="logo-txt">Nomi.na</span>
        </router-link>
      </v-toolbar-title>

      <v-spacer v-if="isMobile || !isAllowed"></v-spacer>

      <v-tabs v-if="!isMobile && isAllowed" color="#C1B7C2" slider-color="primary" centered fixed-tabs
        style="width:initial;">
        <v-tab active-class to="/dashboard/employee">Empleados</v-tab>
        <v-menu>
          <template v-slot:activator="{ on, attrs }">
            <v-tab v-bind="attrs" v-on="on" active-class>Planillas</v-tab>
          </template>

          <v-list>
            <v-list-item to="/dashboard/planilla/attend?type=mensual">
              <v-list-item-title>Asistencia</v-list-item-title>
            </v-list-item>
            <v-list-item to="/dashboard/planilla/payroll?type=pop">
              <v-list-item-title>Población</v-list-item-title>
            </v-list-item>
            <v-list-item to="/dashboard/planilla/payroll">
              <v-list-item-title>Planilla</v-list-item-title>
            </v-list-item>
            <v-list-item to="/dashboard/planilla/payroll?type=dep">
              <v-list-item-title>Departamentos</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
        <v-tab v-if="loggedinUser && loggedinUser.isAdmin" to="/admin" active-class>Gestión de Usuarios</v-tab>
      </v-tabs>

      <div v-if="loggedinUser" class="user-thumb">
        {{ loggedinUser.username }}
        <v-icon @click="onLogout">mdi-logout-variant</v-icon>
      </div>

      <v-icon class="offline" v-if="!isOnline">wifi_off</v-icon>

      <v-menu left bottom v-if="isMobile && isAllowed">
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon v-bind="attrs" v-on="on">
            <v-icon>mdi-dots-vertical</v-icon>
          </v-btn>
        </template>

        <v-list>
          <v-list-item v-for="page in pages" :key="page.path" :to="`/dashboard/${page.path}`">
            <v-list-item-title>{{ page.title }}</v-list-item-title>
          </v-list-item>
          <v-list-item v-if="loggedinUser && loggedinUser.isAdmin" to="/admin">
            <v-list-item-title>Gestión de Usuarios</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>
  </div>
</template>

<script>
export default {
  data() {
    return {
      pages: [
        { title: 'Empleados', path: 'employee' },
        { title: 'Asistencia', path: 'planilla/attend?type=mensual' },
        { title: 'Populacion', path: 'planilla/populacion' },
        { title: 'Planilla', path: 'planilla/payroll' },
        { title: 'Departamentos', path: 'planilla/payroll?type=dep' },
        // { title: 'Statistics', path: 'stats' },
      ]
    }
  },
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.xsOnly;
    },
    loggedinUser() {
      return this.$store.getters['user/loggedinUser']
    },
    isOnline() {
      return this.$store.getters['user/isOnline']
    },
    isAllowed() {
      const { loggedinUser } = this
      return loggedinUser && (loggedinUser.isEditor || loggedinUser.isSupervisor)
    }
  },
  async created() {
    window.addEventListener('offline', () => this.updateOnlineState(false));
    window.addEventListener('online', () => this.updateOnlineState(true));
  },
  destroyed() {
    window.removeEventListener('offline', this.updateOnlineState)
    window.removeEventListener('online', this.updateOnlineState)
  },
  methods: {
    async onLogout() {
      this.$store.dispatch({ type: 'auth/logout' })
    },
    toggleDrawer() {
      this.$store.commit('user/toggleDrawer', true)
    },
    updateOnlineState(newState) {
      this.$store.commit('user/setIsOnline', newState)
    }
  }
}
</script>
